<template>
  <div class="card-cont">
    <div
      class="card-cont-gradient"
      :style="{
        backgroundImage: 'url(' + pageCardTheme.backgroundImage + ')',
      }"
    >
      <div class="card-cont-head">
        <img class="card-cont-avatar" :src="cardInfo.avatar" />
        <div class="card-cont-right">
          <div>
            <div class="card-cont-name">
              {{ cardInfo.name }}
            </div>
            <div v-if="deptListStr" class="card-cont-info">
              {{ deptListStr }}
            </div>
            <div v-if="cardInfo.position" class="card-cont-position text-ellipsis">{{ cardInfo.position }}</div>
          </div>
        </div>
        <img :src="cardInfo.corpLogo" v-if="cardInfo?.corpLogo" class="card-cont-head-logo" />
      </div>
      <div class="card-cont-tag" v-if="cardInfo.tagList && cardInfo.tagList.length">
        <span v-for="(item, index) in cardInfo.tagList" :key="index" class="card-cont-tag-tags">
          {{ item }}
        </span>
      </div>
      <div class="card-cont-foot">
        <div v-if="cardInfo.mobile" class="card-cont-item">
          <span class="cz-iconfont czdianhua2 card-cont-item-icon" />
          <div class="card-cont-item-text">{{ cardInfo.mobile }}</div>
        </div>
        <div v-if="cardInfo.address" class="card-cont-item">
          <span class="cz-iconfont czdizhi card-cont-item-icon" />
          <div class="card-cont-item-text">{{ cardInfo.address }}</div>
        </div>
        <div v-if="cardInfo.desc" class="card-cont-item">
          <span class="cz-iconfont czliangdian card-cont-item-icon" />
          <div class="card-cont-item-text">
            <p v-for="(item, index) in cardInfo.desc.split('\n')" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card-cont-code">
      <div class="card-cont-code-pic"><QrCode :qrCodeUrl="userStore.viewStaffInfo?.qrCode" /></div>
      <p class="card-cont-code-text">长按识别二维码，添加我的企业微信</p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useBusinessCardStore, useUserStore } from '@shared/store';
  import { storeToRefs } from 'pinia';
  import { computed } from 'vue';
  import QrCode from '../qr-code/index.vue';

  const props = defineProps({
    scale: {
      type: Number,
      default: 1,
    },
  });

  const theme = {
    scale: props?.scale || 1,
  };

  const userStore = useUserStore();
  const cardStore = useBusinessCardStore();
  const { pageCardTheme, pageCardInfo: cardInfo } = storeToRefs(cardStore);

  const deptListStr = computed(() => {
    let _deptlist = cardInfo.value?.corpName ? [cardInfo.value?.corpName] : [];
    if (cardInfo.value?.deptList && cardInfo.value?.deptList.length) {
      _deptlist = _deptlist.concat(cardInfo.value?.deptList);
    }
    return _deptlist.join(' | ');
  });
</script>

<style lang="less" scoped>
  .card-cont {
    background-color: #fff;
    border-radius: 4px;
    &-gradient {
      background-color: #f6f8fb;
      background-position: right bottom;
      background-repeat: no-repeat;
      background-size: 100%;
      padding: calc(v-bind('theme.scale') * 13px) 15px 20px;
    }
    &-head {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;
      &-logo {
        position: absolute;
        right: 0;
        top: 0;
        width: 90px;
        height: auto;
      }
    }
    &-avatar {
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
    &-right {
      padding-left: 20px;
      flex: 1;
    }
    &-name {
      font-size: 18px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 8px;
    }
    &-position {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    &-info {
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    &-tag {
      margin: 20px 0 12px;
      &-tags {
        padding: 5px 15px;
        background: #ffffff;
        border-radius: 13px;
        border: 1px solid #ffffff;
        margin-right: 10px;
        font-size: 13px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 3px;
      }
    }
    &-foot {
    }
    &-item {
      display: flex;
      padding: 0.1rem 0;
      &-text {
        font-size: 11px;
        font-weight: 400;
        color: #333333;
        line-height: 14px;
        word-break: break-all;
        flex: 1;
      }
      &-icon {
        margin-right: 10px;
        font-size: 0.24rem;
      }
    }
    &-code {
      padding: 30px;
      text-align: center;
      &-pic {
        margin: 0 auto;
        width: 200px;
        height: 200px;
      }
      &-text {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        margin-top: 15px;
      }
    }
  }
</style>
